export const MFA_RATE_LIMIT_WINDOW = 15 * 60 * 1000;
export const MFA_MAX_SMS_SENDS = 3;
export const MFA_MAX_FAILED_ATTEMPTS = 5;
export const MFA_DEFAULT_LOCKOUT_DURATION = 15 * 60 * 1000;
export const MFA_TOTP_CODE_LENGTH = 6;
export const MFA_SMS_CODE_LENGTH = 6;
export const MFA_RECOVERY_CODE_LENGTH = 8;


const MFA_RECOVERY_CODE_CHARS = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";

/** Generate display-only recovery codes (XXXX-XXXX). Server stores only hashes. */
export function generateMfaRecoveryCodes(count = 10): string[] {
  const codes: string[] = [];
  const cryptoObj =
    typeof globalThis !== "undefined" ? globalThis.crypto : undefined;
  for (let i = 0; i < count; i++) {
    let raw = "";
    if (cryptoObj?.getRandomValues) {
      const bytes = new Uint8Array(MFA_RECOVERY_CODE_LENGTH);
      cryptoObj.getRandomValues(bytes);
      for (let j = 0; j < MFA_RECOVERY_CODE_LENGTH; j++) {
        raw += MFA_RECOVERY_CODE_CHARS[bytes[j] % MFA_RECOVERY_CODE_CHARS.length];
      }
    } else {
      for (let j = 0; j < MFA_RECOVERY_CODE_LENGTH; j++) {
        raw +=
          MFA_RECOVERY_CODE_CHARS[
            Math.floor(Math.random() * MFA_RECOVERY_CODE_CHARS.length)
          ];
      }
    }
    codes.push(raw.slice(0, 4) + "-" + raw.slice(4));
  }
  return codes;
}

/** Normalize a typed recovery code to its canonical form (A-Z0-9, upper). */
export function normalizeMfaRecoveryCode(code: string): string {
  return code.toUpperCase().replace(/[^A-Z0-9]/g, "");
}

/** True when a typed recovery code has the expected canonical length. */
export function isValidMfaRecoveryCodeFormat(code: string): boolean {
  return normalizeMfaRecoveryCode(code).length === MFA_RECOVERY_CODE_LENGTH;
}

export function mfaToE164(phone: string | null): string | null {
  if (!phone) return null;
  const trimmed = phone.trim();
  if (!trimmed) return null;
  return trimmed.startsWith("+") ? trimmed : `+${trimmed}`;
}

export function maskMfaPhone(phone: string): string {
  if (phone.length <= 6) return phone;
  return phone.slice(0, 3) + "****" + phone.slice(-4);
}

export function mfaLockoutMessage(lockedUntil: number | null): string {
  const remainingSec = lockedUntil
    ? Math.max(0, Math.ceil((lockedUntil - Date.now()) / 1000))
    : 900;
  const remainingMin = Math.max(1, Math.ceil(remainingSec / 60));
  return `Account temporarily locked. Try again in ${remainingMin} minute${remainingMin > 1 ? "s" : ""}.`;
}
